import React, { useState } from "react";

/**
 * Authentic WhatsApp-style Default Profile Picture (Blank DP)
 * Displays the iconic neutral circular avatar with clean silhouette.
 */
export const WhatsAppBlankAvatar = ({ className = "w-full h-full", iconClassName = "" }) => (
  <div className={`relative flex items-center justify-center bg-[#DFE5E7] dark:bg-[#202C33] overflow-hidden ${className}`}>
    <svg
      viewBox="0 0 120 120"
      className={`w-full h-full ${iconClassName}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* WhatsApp classic head */}
      <circle cx="60" cy="45" r="22" className="fill-[#FFFFFF] dark:fill-[#6A7B85]" />
      {/* WhatsApp classic curved shoulders */}
      <path
        d="M22,112 C22,86 40,75 60,75 C80,75 98,86 98,112 Z"
        className="fill-[#FFFFFF] dark:fill-[#6A7B85]"
      />
    </svg>
  </div>
);

/**
 * Universal User Avatar
 * If user has uploaded a custom picture, displays that photo.
 * If picture is blank, missing, or a dummy URL, seamlessly displays WhatsApp blank DP.
 */
export const UserAvatar = ({
  src,
  alt = "User Avatar",
  className = "w-10 h-10 rounded-full",
  imgClassName = "object-cover",
}) => {
  const [loadError, setLoadError] = useState(false);
  const cleanSrc = (src || "").trim();
  const isDummy = cleanSrc.includes("photo-1534528741775") || cleanSrc.includes("photo-1507003211169");

  if (!cleanSrc || isDummy || loadError) {
    return <WhatsAppBlankAvatar className={className} />;
  }

  return (
    <div className={`overflow-hidden shrink-0 ${className}`}>
      <img
        src={cleanSrc}
        alt={alt}
        className={`w-full h-full ${imgClassName}`}
        onError={() => setLoadError(true)}
      />
    </div>
  );
};

export default UserAvatar;
